import AbstractListView from '@UI/Store/AbstractListView';
import type OrganizationView from '@UI/Store/Organizations/Views/OrganizationView';

/** Immutable View: `readonly` properties, frozen at the end of the constructor. */
class OrganizationsListView extends AbstractListView<OrganizationView> {
	readonly accountId: number;

	constructor(list: readonly OrganizationView[], accountId: number) {
		super(list, 'OrganizationsListView');

		this.accountId = accountId;

		Object.freeze(this);
	}

	addOrganization(organization: OrganizationView): OrganizationsListView {
		return new OrganizationsListView([...this.list, organization], this.accountId);
	}

	updateOrganization(organization: OrganizationView): OrganizationsListView {
		return new OrganizationsListView(
			this.list.map((entry) => (entry.id === organization.id ? organization : entry)),
			this.accountId,
		);
	}

	removeOrganization(organizationId: number): OrganizationsListView {
		return new OrganizationsListView(
			this.list.filter((entry) => entry.id !== organizationId),
			this.accountId,
		);
	}
}

export default OrganizationsListView;
